import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterDMNHAXE({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    nha_xe: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.nha_xe) {
      condition.$or.push({
        ma_dt: { $regex: filter.nha_xe?.split(" ").join(".*"), $options: "i" },
      });
      condition.$or.push({
        ten_dt: { $regex: filter.nha_xe?.split(" ").join(".*"), $options: "i" },
      });
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Mã, tên nhà xe"
        placeholder="Tìm theo mã, tên nhà xe"
        value={filter.nha_xe}
        onSearch={(val) => setFilter({ ...filter, nha_xe: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMNHAXE;
